import React, { useEffect, useState, ButtonHTMLAttributes } from 'react';

import Image from 'next/image';

import { motion, useAnimation, MotionProps } from 'framer-motion';

type MotionButtonProps = MotionProps & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'>;

const MotionButton = motion.button as React.ComponentType<MotionButtonProps>;

const Roulette = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [spinCount, setSpinCount] = useState(0);
  const controls = useAnimation();
  const [spinSound, setSpinSound] = useState<HTMLAudioElement | null>(null);
  const [stop1Sound, setStop1Sound] = useState<HTMLAudioElement | null>(null);
  const [stop2Sound, setStop2Sound] = useState<HTMLAudioElement | null>(null);

  useEffect(() => {
    const spin = new Audio('/img/v2/sound/roulette.mp3');
    const stop1 = new Audio('/img/v2/sound/lose.mp3');
    const stop2 = new Audio('/img/v2/sound/win.mp3');

    setSpinSound(spin);
    setStop1Sound(stop1);
    setStop2Sound(stop2);
  }, []);

  const spin = async () => {
    if (isSpinning || !spinSound || !stop1Sound || !stop2Sound) return;

    setIsSpinning(true);

    const baseRotation = rotation;
    let newRotation = 0;

    if (spinCount === 0) {
      newRotation = baseRotation + 360 * 2.5;

      spinSound.play();

      await controls.start({
        rotate: newRotation,
        transition: {
          duration: 5,
          ease: [0.1, 0.1, 0.1, 1],
        },
      });

      spinSound.pause();
      spinSound.currentTime = 0;
      stop1Sound.play();
    } else if (spinCount === 1) {
      newRotation = baseRotation + 360 * 3.5 + 38;

      spinSound.play();

      await controls.start({
        rotate: newRotation,
        transition: {
          duration: 5,
          ease: [0.1, 0.1, 0.1, 1],
        },
      });

      spinSound.pause();
      spinSound.currentTime = 0;
      stop2Sound.play();
      setShow(true);
    }

    setRotation(newRotation);
    setSpinCount(spinCount + 1);
    setIsSpinning(false);
  };

  return (
    <div className="relative flex flex-col items-center justify-center w-full h-full pt-16 ">
      <div className="relative w-[255px] h-[270px] flex items-center justify-center">
        <Image
          src="/img/v2/register/frame.webp"
          alt="Marco Ruleta"
          width={255}
          height={300}
          priority
          className="absolute top-0 left-0 z-30 -mt-16"
        />
        <motion.div
          animate={controls}
          className="relative z-20"
          style={{
            width: '236px',
            height: '236px',
          }}
        >
          <Image
            src="/img/v2/register/roulette.webp"
            alt="Ruleta"
            width={236}
            height={236}
            priority
            className="w-full h-full"
          />
        </motion.div>
      </div>

      <div className="absolute top-1/2 left-1/2 z-50 mt-9" style={{ transform: 'translate(-50%, -50%)' }}>
        <MotionButton
          type="button"
          onClick={spin}
          disabled={isSpinning}
          data-testid="spin-button"
          aria-label="Spin roulette wheel"
          className="w-20 h-20 bg-[url('/img/v2/register/button.webp')] bg-no-repeat bg-cover text-black font-bold rounded-full z-50"
          whileTap={{
            scale: 0.85,
            transition: { duration: 0.1 },
          }}
        />
      </div>
    </div>
  );
};

export default Roulette;
